/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEquipmentintervalDto } from '../models/work-create-equipmentinterval-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkEquipmentinterval } from '../models/work-equipmentinterval';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateEquipmentintervalDto } from '../models/work-update-equipmentinterval-dto';

@Injectable({ providedIn: 'root' })
export class WorkEquipmentintervalsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `equipmentintervalsV2ControllerGetAllDropdownOptions()` */
  static readonly EquipmentintervalsV2ControllerGetAllDropdownOptionsPath = '/v2/equipmentintervals/dropdown-options';

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: equipments:read, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.equipmentintervalsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerFindAllPaginated()` */
  static readonly EquipmentintervalsV2ControllerFindAllPaginatedPath = '/v2/equipmentintervals';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by equipmentId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentId=$not:$like:John Doe&filter.equipmentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentinterval>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.equipmentId', params['filter.equipmentId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEquipmentinterval>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'equipmentId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by equipmentId query param.
     *           <p>
     *              <b>Format: </b> filter.equipmentId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.equipmentId=$not:$like:John Doe&filter.equipmentId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.equipmentId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentinterval>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
};
};
}> {
    return this.equipmentintervalsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentinterval>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEquipmentinterval>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'equipmentId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerCreate()` */
  static readonly EquipmentintervalsV2ControllerCreatePath = '/v2/equipmentintervals';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentintervalsV2ControllerCreate$Response(
    params: {
      body: WorkCreateEquipmentintervalDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentinterval>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentinterval>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentintervalsV2ControllerCreate(
    params: {
      body: WorkCreateEquipmentintervalDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmentinterval> {
    return this.equipmentintervalsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentinterval>): WorkEquipmentinterval => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerFindAllUnique()` */
  static readonly EquipmentintervalsV2ControllerFindAllUniquePath = '/v2/equipmentintervals/unique';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerFindAllUnique()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindAllUnique$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEquipmentinterval>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerFindAllUniquePath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEquipmentinterval>>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerFindAllUnique$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindAllUnique(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkEquipmentinterval>> {
    return this.equipmentintervalsV2ControllerFindAllUnique$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEquipmentinterval>>): Array<WorkEquipmentinterval> => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerFindOneById()` */
  static readonly EquipmentintervalsV2ControllerFindOneByIdPath = '/v2/equipmentintervals/{id}';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentinterval>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentinterval>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEquipmentinterval> {
    return this.equipmentintervalsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentinterval>): WorkEquipmentinterval => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerDelete()` */
  static readonly EquipmentintervalsV2ControllerDeletePath = '/v2/equipmentintervals/{id}';

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: equipments:delete, equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  equipmentintervalsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.equipmentintervalsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `equipmentintervalsV2ControllerUpdate()` */
  static readonly EquipmentintervalsV2ControllerUpdatePath = '/v2/equipmentintervals/{id}';

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `equipmentintervalsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentintervalsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEquipmentintervalDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEquipmentinterval>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEquipmentintervalsV2Service.EquipmentintervalsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEquipmentinterval>;
      })
    );
  }

  /**
   * Required permissions: equipments:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `equipmentintervalsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  equipmentintervalsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEquipmentintervalDto
    },
    context?: HttpContext
  ): Observable<WorkEquipmentinterval> {
    return this.equipmentintervalsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEquipmentinterval>): WorkEquipmentinterval => r.body)
    );
  }

}
